import { Model } from "@interfaces/model.interface";
import { Guid } from "guid-typescript";

export interface ClientDocument extends Model {
	clientId: number;
	description: string;
	fileId: number;
	fileLookupId: Guid;
	fileName: string;
}

export class ClientDocument implements ClientDocument {
	clientId = 0;
	description = "";
	fileId = 0;
	fileName = "";

	constructor(data?: Partial<ClientDocument>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}